import axios from 'axios'
import router from './../../../router'

const namespaced = true;

const state = {
  idToken: null,
  expiryDate: null,
  };

const getters = {
  isAuthenticated (state) {
    const now = new Date();
    if(state.idToken !== null && state.expiryDate > now){return true}
    return false;
  }
};

const mutations = {
    authUser (state, userData) {
      state.idToken = userData.token
      state.expiryDate = userData.expiryDate
    },
    clearAuthData (state) {
      state.idToken = null
      state.expiryDate = null
    }
  };


const actions = {
    setLogoutTimer ({commit}, expirationTime) {
      setTimeout(() => {
        commit('clearAuthData')
      }, expirationTime * 1000)
    },
    signup ({commit, dispatch}, authData) {
      return new Promise((resolve, reject) => {
        axios.post('/api/accounts/account', {
          name: authData.name,
          company: authData.company,
          email: authData.email,
          password: authData.password,
          password_confirmation: authData.password_confirmation
        })
          .then(res => {
            resolve(res.data);
          })
          .catch(error => {
            reject(error.response);
          })
      })
    },
    login ({commit, dispatch}, authData) {
      return new Promise((resolve, reject) => {

          axios.post('/oauth/token', {
            username: authData.email,
            password: authData.password,
            grant_type: "password",
            client_id: "2",
            client_secret: "YVH0kQLSfVOny1AtIuK4ta9kqd1kfJSTZEjCE0fl",
            scope: "*"
        })
          .then(res => {
            const now = new Date()
            const expirationDate = new Date(now.getTime() + res.data.expires_in * 1000)
            localStorage.setItem('token', res.data.access_token)
            localStorage.setItem('expirationDate', expirationDate)
            commit('authUser', {
              token: res.data.access_token,
              expiryDate: expirationDate
            })
            dispatch('setLogoutTimer', res.data.expires_in)
            location.reload()
            resolve(res.data);
          })
          .catch(error => {
            reject(error.response);
          })
      })
    },
    tryAutoLogin ({commit}) {
      const token = localStorage.getItem('token')
      if (!token) {
        return
      }
      const expirationDate = new Date(localStorage.getItem('expirationDate'))
      const now = new Date()
      if (now >= expirationDate) {
        return
      }

      commit('authUser', {
        token: token,
        expiryDate: expirationDate,
      })
    },
    logout ({commit}) {
      commit('clearAuthData')
      localStorage.removeItem('expirationDate')
      localStorage.removeItem('token')
      router.replace('/login')
      location.reload()
    }
  };


export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/security/auth.js